<div class="dialog-container">
  <h2 mat-dialog-title>Add Participants</h2>

  <mat-dialog-content>
    <!-- Search Bar -->
    <div class="search-section mb-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Search Employees</mat-label>
        <input
          matInput
          [formControl]="searchControl"
          placeholder="Type to search by name or email..."
          autocomplete="off"
        />
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </div>

    <!-- Action Buttons -->
    <div class="action-buttons mb-3 d-flex gap-2">
      <button mat-stroked-button color="primary" (click)="selectAll()">
        <mat-icon>done_all</mat-icon>
        Select All
      </button>
      <button mat-stroked-button color="warn" (click)="clearAll()">
        <mat-icon>clear</mat-icon>
        Clear All
      </button>
      <div class="ms-auto">
        <span class="badge bg-primary">{{ selectedParticipants.length }} Selected</span>
      </div>
    </div>

    <!-- Selected Participants Chips -->
    <div class="selected-section mb-3" *ngIf="selectedParticipants.length > 0">
      <label class="fw-bold mb-2">Selected Participants:</label>
      <div class="chips-container">
        <mat-chip-list>
          <mat-chip
            *ngFor="let participant of selectedParticipants"
            [removable]="true"
            (removed)="removeParticipant(participant)"
            color="primary"
            selected>
            {{ participant.name }}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
        </mat-chip-list>
      </div>
    </div>

    <!-- Employee List -->
    <div class="employee-list-section">
      <label class="fw-bold mb-2">Available Employees:</label>
      <div class="employee-list">
        <mat-selection-list>
          <mat-list-option
            *ngFor="let employee of filteredEmployees$ | async"
            [selected]="isSelected(employee)"
            (click)="toggleSelection(employee)"
            checkboxPosition="before">
            <div class="employee-item">
              <div class="employee-name">{{ employee.name }}</div>
              <div class="employee-email text-muted">{{ employee.email }}</div>
            </div>
          </mat-list-option>
        </mat-selection-list>
      </div>
    </div>
  </mat-dialog-content>

  <!-- Dialog Actions -->
  <mat-dialog-actions align="end" class="dialog-actions">
    <button mat-raised-button color="warn" (click)="onCancel()">
      Cancel
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="onAdd()"
      [disabled]="selectedParticipants.length === 0">
      Add Participants ({{ selectedParticipants.length }})
    </button>
  </mat-dialog-actions>
</div>
